<section class="mbs-wizard_form">
  <div class="mbs-wizard_form-content">
    @if (noData) {
      <mbs-alert
        [attr.data-e2e]="elementsSelector.name.noStoragesAlert"
        [type]="mbsPopupType.warning"
        [icon]="true">
        {{ 'wizards:whereBackup.where_backup_no_storages' | i18next }}
      </mbs-alert>
    } @else {
      <mbs-list-select
        bindSelected="ID"
        [id]="id"
        [tooltipForDisabledRow]="{
          text: disableRowTooltip,
          placement: 'top-left',
          container: 'body',
          closeOnScroll: true
        }"
        [tableContentClass]="'cursor-pointer'"
        [invalid]="invalid"
        [keepState]="true"
        [loadSource]="false"
        [maxHeight]="maxHeight"
        [multipleSelect]="false"
        [showCheckboxes]="false"
        [showHeaders]="false"
        [showSearch]="false"
        [selectedData]="selectedStorages"
        [data]="storages"
        (click)="rowClick.emit()"
        (changeSelected)="changeSelected.emit($event)"
        [headers]="headers">
        <ng-template
          mbsTableCell
          let-dStorage>
          <div class="form-row flex-nowrap">
            <div class="col-auto d-flex align-items-center">
              <span
                class="mbs-storage mbs-storage-sm mbs-storage_{{ dStorage.StorageType | storageIcon: false : !dStorage.IsLocal }}"></span>
            </div>
            <div class="col text-overflow fw-semibold text-black">
              <span>{{ dStorage.DisplayName }}</span>
            </div>
            @if (dStorage.ImmutabilityPeriodDays) {
              <div class="col-auto d-flex align-items-center pr-0">
                <span class="text-xs fw-semibold text-black bg-cyan-20 p-1 pt-0 border-radius-sm">
                  <span class="ico ico-Lock"></span>
                  <span class="ml-1">
                    {{ 'wizards:common.objectLockIsEnabled' | i18next: { format: 'uppercase', count: dStorage.ImmutabilityPeriodDays } }}
                  </span>
                </span>
              </div>
            }
          </div>
        </ng-template>
      </mbs-list-select>
    }
  </div>
</section>
